import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-disclaimer">
          <p className="footer-disclaimer-text">
            <span className="footer-warning">⚠️</span>
            For Educational Purposes Only | Not Financial Advice
            <Link to="/disclaimer" className="footer-disclaimer-link">
              View Full Disclaimer
            </Link>
          </p>
        </div>
        <div className="footer-info">
          <p className="footer-copyright">
            © 2024 Bitcoin Wealth Builder | All calculations are estimates
          </p>
          <div className="footer-legal-links" style={{ marginTop: '8px' }}>
            <Link to="/terms" className="footer-legal-link">
              Terms of Service
            </Link>
            <span className="footer-legal-separator"> | </span>
            <Link to="/privacy" className="footer-legal-link">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;